import { forwardRef, ComponentPropsWithoutRef } from 'react'
import Icon from '@/components/Icon'
import { numberWithCommas } from '@/util/numberHelpers'
import { classNames } from '@/util/tailwindHelpers'

interface PointsDisplayProps extends ComponentPropsWithoutRef<'div'> {
  value: number | string
  showSuffix?: boolean
  iconClassName?: string
}

// NOTE - Requires parent with container query to engage responsive styles

const PointsDisplay = forwardRef<HTMLDivElement, PointsDisplayProps>(
  ({ value, className, iconClassName, showSuffix = true, ...rest }, ref) => {
    const transformedValue =
      typeof value === 'string' ? value : numberWithCommas(value)

    return (
      <div
        ref={ref}
        className={classNames(
          'flex items-center gap-half',
          'pricing-lg @xl:pricing-xl',
          className
        )}
        {...rest}
      >
        <Icon
          name="arcade"
          className={classNames(
            'w-[18px] h-[18px] @xl:w-[20px] @xl:h-[20px] flex-shrink-0',
            iconClassName
          )}
        />
        <div className="flex leading-none items-baseline gap-[inherit]">
          <span>{transformedValue}</span>
          {showSuffix && <span className="pricing-sm text-gray-300">PTS</span>}
        </div>
      </div>
    )
  }
)

export default PointsDisplay
